<template>
  <form class="login-form" @submit.prevent="handleSubmit">
    <h1>Bem-vindo</h1>

    <Select class="input-full" :options="schemaOptions" legend="Autoescola"
      :placeholder="schemaOptions.length ? 'Selecione uma auto escola' : 'Carregando auto escolas'" :modelValue="schema"
      @update:modelValue="$event => (schema = $event)" :disabled="!loaded || !schemaOptions.length || loading"
      variant="dark" />

    <div class="form-content">
      <input type="email" style="display: none;" autocomplete="username" />
      <input type="password" style="display: none;" autocomplete="current-password" />

      <Input type="email" legend="Email" :modelValue="email" @update:modelValue="$event => (email = $event)"
        variant="dark" :disabled="loading" name="email" />

      <Input type="password" legend="Senha" :modelValue="password" @update:modelValue="$event => (password = $event)"
        variant="dark" :disabled="loading" name="password" />
    </div>

    <div class="links" v-if="schema">
      <label class="custom-checkbox">
        <input type="checkbox" v-model="remember" />
        <span class="checkmark"></span>
        <span class="label-text">Lembrar-me</span>
      </label>

      <router-link class="remember-link" :to="{ name: 'redefinir-senha', params: { autoescola: schema } }" data-testid="esqueci-senha-link">
        Esqueci minha senha
      </router-link>
    </div>

    <Button type="submit" :text="loading ? 'ENTRANDO...' : 'ENTRAR'" color="primary" :disabled="loading" />

    <template v-if="schema">
      <div class="divider">
        <span class="divider-text">ou</span>
      </div>

      <div class="options">
        <router-link class="option-button" :to="{ name: 'loginAluno', params: { autoescola: schema } }">
          <span class="button-icon primary">
            <AccountOutline :size="24" />
          </span>

          Sou aluno
        </router-link>

        <router-link class="option-button" :to="{ name: 'loginInstrutor', params: { autoescola: schema } }">
          <span class="button-icon secondary">
            <SchoolOutline :size="24" />
          </span>

          Sou Instrutor
        </router-link>
      </div>

      <span>NovoCFC: {{ schemaDisplay }}</span>
    </template>
  </form>
</template>

<script>
import Button from 'core/Button'
import Input from 'core/Input'
import Select from 'core/Select'

import AccountOutline from 'icons/AccountOutline'
import SchoolOutline from 'icons/SchoolOutline'

import store from '../../../store'

export default {
  name: 'login',
  components: {
    Select,
    Input,
    Button,

    AccountOutline,
    SchoolOutline,
  },
  computed: {
    schemaDisplay () {
      if (this.schema && this.schema.startsWith('autonomo_')) {
        return 'autonomo_***********'
      }
      return this.schema
    },
  },
  data () {
    return {
      schema: null,
      email: '',
      password: '',
      schemaOptions: [],
      loaded: false,
      remember: false,
      loading: false,
    }
  },
  async mounted () {
    await this.fetchCfcs()

    const schemaStorage = localStorage.schema
    const routeParam = this.$router.currentRoute.params.autoescola

    if (
      schemaStorage &&
      schemaStorage !== 'public' &&
      schemaStorage !== 'undefined' &&
      schemaStorage !== 'null'
    ) {
      this.schema = schemaStorage
    }

    if (routeParam && routeParam !== 'dashboard') {
      this.schema = routeParam === 'novocfc-monitoramento' ? '' : routeParam
    }

    this.loaded = true
  },
  methods: {
    async fetchCfcs () {
      await this.$http
        .get(`${process.env.VUE_APP_URL_API_V2}/public/autoescola`, {
          headers: {
            apiPublicToken: btoa(
              'f07907757636178fee6d9a6e672863a2' + new Date().toISOString().slice(14, 16)
            ),
            authorization: '',
          },
        })
        .then(res => {
          this.schemaOptions = res.body.dados
            .filter(cfc => cfc.nome_fantasia !== 'TESTE')
            .map(cfc => ({
              value: cfc.tenant_schema,
              text: cfc.nome_fantasia,
            }))
        })
        .catch(error => {
          this.$toasted.show('Erro!' + error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async handleSubmit () {
      if (this.validateInputs()) {
        await this.login()
      }
    },
    validateInputs () {
      if (!this.email || !this.password) {
        this.$toasted.show('Preencha os campos de email e senha!', {
          icon: 'fa-times',
          position: 'top-right',
          duration: 5000,
          fullWidth: false,
        })

        return false
      }

      return true
    },
    async login () {
      localStorage.clear()

      this.loading = true

      await this.$http
        .post(`${process.env.VUE_APP_URL_API}/login`, {
          autoescola: this.schema,
          username: this.email,
          password: this.password,
        })
        .then(({ body }) => {
          window.localStorage['usuario'] = JSON.stringify(body.usuario)
          window.localStorage['token'] = body.access_token
          window.localStorage['refresh_token'] = body.refresh_token
          window.localStorage['id_role'] = body.id_role
          window.localStorage['role'] = body.role
          window.localStorage['schema'] = body.schema
          window.localStorage['cfc'] = body.cfc
          window.localStorage['url'] = body.url
          window.localStorage['email'] = body.email
          window.localStorage['autoescola'] = JSON.stringify(body.autoescola)
          window.localStorage['nome_fantasia'] = body.nome_fantasia
          window.localStorage['gratuidade_teorica'] = body.gratuidade_teorica
          window.localStorage['gratuidade_pratica'] = body.gratuidade_pratica
          window.localStorage['permissions'] = JSON.stringify(body.role.permissions)

          store.commit('authenticated')

          const routeMap = {
            2: 'DashboardMonitoramento',
            6: 'faturas_boletos',
            7: 'EnvioAulasPraticas',
            8: 'lista-autoescolas',
            9: 'Getran-listarAlunos',
          }

          const roleId = body.role.id_funcao_usuario
          const routeName = routeMap[roleId] || 'dashboard'

          this.$router.push({ name: routeName })
        })
        .catch(({ body }) => {
          if (body && body.selecao_necessaria) {
            const schemasPermitidos = body.autoescolas.map(a => a.schema)
            this.schemaOptions = body.autoescolas.map(a => ({
              value: a.schema,
              text: a.nome_fantasia,
            }))
            this.schema = schemasPermitidos.length === 1 ? schemasPermitidos[0] : null
            this.$toasted.show(body.mensagem, {
              icon: 'fa-info-circle',
              position: 'top-right',
              duration: 7000,
              fullWidth: false,
            })
            return
          }
          this.$toasted.show(body.mensagem, {
            icon: 'fa-times',
            position: 'top-right',
            duration: 5000,
            fullWidth: false,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.login-form {
  display: flex;
  flex-direction: column;
  gap: 2rem;

  h1 {
    margin: 0;
    font-weight: 700;
    font-size: 3rem;
    line-height: 100%;
    letter-spacing: -0.11px;
    color: #202224;
  }

  .form-content {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .links {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;

    .custom-checkbox {
      margin: 0;
      display: flex;
      align-items: center;
      cursor: pointer;
      user-select: none;

      input {
        display: none;
      }

      .checkmark {
        width: 0.9375rem;
        height: 0.9375rem;
        border: 2px solid #707070;
        border-radius: 3px;
        background-color: transparent;
        display: inline-block;
        position: relative;
        margin-right: 0.5rem;
        box-sizing: border-box;
        transition: background-color 0.2s;
      }

      input:checked+.checkmark {
        background-color: #1b2c5a;
      }

      .label-text {
        font-weight: 400;
        font-size: 1rem;
        line-height: 100%;
        letter-spacing: 0%;
        color: #606264;
      }
    }

    .remember-link {
      all: unset;
      font-weight: 400;
      font-size: 1rem;
      line-height: 100%;
      letter-spacing: 0%;
      text-align: right;
      text-decoration: underline;
      color: #606264;
      cursor: pointer;
    }
  }

  >Button {
    height: auto;
    padding: 1.25rem;
    justify-content: center;
    font-size: 1rem;
    font-family: Inter;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: 0%;
  }

  .divider {
    display: flex;
    align-items: center;
    text-align: center;
    width: 100%;

    &::before,
    &::after {
      content: '';
      flex: 1;
      border-bottom: 1px solid #ccc;
    }

    .divider-text {
      margin: 0 1rem;
      color: #666;
      font-weight: 500;
    }
  }

  .options {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;

    .option-button {
      all: unset;
      min-width: 8rem;
      flex: 1;
      padding: 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0.5rem;
      border: 1px solid #1c2d5a;
      border-radius: 12.27px;
      cursor: pointer;

      font-weight: 800;
      font-size: 1.1rem;
      line-height: 100%;
      letter-spacing: 0.46px;
      color: #1c2d5a;

      .button-icon {
        width: 2.316875rem;
        height: 2.199375rem;
        display: flex;
        justify-content: center;
        align-items: center;

        border-radius: 10px;
      }

      .primary {
        color: #072d93;
        background-color: rgba(7, 45, 147, 0.21);
      }

      .secondary {
        color: #ffc20e;
        background-color: rgba(255, 194, 14, 0.21);
      }
    }
  }

  >span {
    text-align: center;
    font-weight: 600;
    font-size: 0.75rem;
    line-height: 100%;
    letter-spacing: -0.11px;
  }
}
</style>
